// extracted by mini-css-extract-plugin
module.exports = {"tooltipPoratal":"styles_tooltipPoratal__2ond0","body":"styles_body__2gh24","hint":"styles_hint__2t6sx"};